import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import AiToolTemplateV2 from '../../AiToolTemplate/AiToolTemplateV2';
import { createComponentConfig, createComponentItem, COMPONENT_TYPES, PROMPT_STRATEGIES, TOOL_IDS } from '../../AiToolTemplate/config/componentConfig';

const WorldView = () => {
  const { t } = useI18n();

  const worldViewConfig = createComponentConfig({
    toolName: t('aiWorkbench.tools.worldView.title') || '全球打卡',
    toolIcon: '🌍',
    toolDescription: t('aiWorkbench.tools.worldView.description') || t('aiWorkbench.tools.worldView.ui.promptDescription'),
    gradientColors: ['#4facfe', '#00f2fe'],
    apiEndpoint: '/generate-image/edit',
    apiParams: {},
    components: [
      createComponentItem({
        id: 'mapInfo',
        type: COMPONENT_TYPES.PLACE_PICKER,
        title: t('aiWorkbench.tools.worldView.mapCard.title'),
        description: t('aiWorkbench.tools.worldView.mapCard.description'),
        required: true,
        defaultValue: null,
        props: {},
        promptKey: 'mapInfo',
        order: 1,
        height: 340,
        visible: true
      }),
      createComponentItem({
        id: 'photos',
        type: COMPONENT_TYPES.IMAGE_UPLOAD,
        title: t('aiWorkbench.tools.worldView.ui.uploadTitle'),
        description: t('aiWorkbench.tools.worldView.ui.uploadDescription'),
        required: true,
        props: { multiple: true, preview: true, gridItemHeight: 100, maxFiles: 6, uploadAreaHeight: 120 },
        promptKey: 'images',
        order: 2
      }),
      createComponentItem({
        id: 'size',
        type: COMPONENT_TYPES.SIZE_SELECTOR,
        title: t('aiWorkbench.aspectRatio'),
        required: true,
        defaultValue: 'Auto',
        order: 3
      }),
      createComponentItem({
        id: 'mapTimeWeather',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'mapTimeWeather',
          allowMultiple: false
        },
        order: 4
      }),
      createComponentItem({
        id: 'mapOutfit',
        type: COMPONENT_TYPES.TAG_SELECTOR,
        required: false,
        props: {
          dictName: 'mapOutfit',
          allowMultiple: false
        },
        order: 5
      }),
      createComponentItem({
        id: 'userPrompt',
        type: COMPONENT_TYPES.PROMPT_INPUT,
        title: t('aiWorkbench.tools.worldView.ui.promptTitle'),
        description: t('aiWorkbench.tools.worldView.ui.promptDescription'),
        required: false,
        props: { placeholder: t('aiWorkbench.tools.worldView.ui.promptPlaceholder') },
        promptKey: 'prompt',
        order: 6
      }),
    ],
    promptConfig: {
      strategy: PROMPT_STRATEGIES.CUSTOM,
      customHandler: (values) => {
        return values.userPrompt;
      }
    },
    additionalParams: {
      width: 1024,
      height: 1024,
      model: 'nano'
    },
    layout: 'default'
  });

  return (
    <AiToolTemplateV2
      toolName={worldViewConfig.toolName}
      toolIcon={worldViewConfig.toolIcon}
      toolDescription={worldViewConfig.toolDescription}
      config={worldViewConfig}
      gradientColors={worldViewConfig.gradientColors}
      toolId={TOOL_IDS.WORLD_VIEW}
    />
  );
};

export default WorldView;
